import React, { useEffect, useState } from 'react';
import './App.scss';
import data from './data/content.json';
import { ContentProvider } from './context/ContentProvider';
import { IContent } from './types';
import { bindActionCreators } from 'redux';
import { connect, ConnectedProps } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { fetchProducts, setFTEligible } from './store/actions/productAction';
import UbisoftPLusLoader from './components/UbisoftPlusLoader/UbisoftPlusLoader';
import Hero from './components/Hero/Hero';
import Description from './components/Description/Description';
import Advantages from './components/Advantages/Advantages';
import FAQ from './components/FAQ/FAQ';
import { AppActions } from './types/store/action';
import { AppState } from './store';
import '../node_modules/slick-carousel/slick/slick.scss';
import '../node_modules/slick-carousel/slick/slick-theme.css';
import { setUpWaData } from './utils';
import BannerList from './components/Banners/BannerList';
import Legal from './components/Legal/Legal';
import { Konami } from './components/Konami/Konami';
import UbisoftPlusNavigation from './components/UbisoftPlusNavigation/UbisoftPlusNavigation';
import { StyleSheetManager } from 'styled-components';
import PriceBannerBlock from './components/PriceBannerBlock/PriceBannerBlock';
import Banner from './components/Banners/Banner';
import './components/Banners/Banners.scss'

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, AppActions>) => ({
  fetchProducts: bindActionCreators(fetchProducts, dispatch),
  setFTEligible: bindActionCreators(setFTEligible, dispatch)
});

const mapStateToProps = (state: AppState) => ({
  products: state.products
});

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;
type AppProps = PropsFromRedux & {
  localeId: string;
};

const App = (props: AppProps) => {
  const { localeId, fetchProducts, setFTEligible, products } = props;
  const localizedContent: IContent = data.filter(
    (locale) => locale.lang === localeId
  )[0];

  const [konamiState,setKonamiState] = useState(false)
  let konami = new Konami();

  useEffect(() => {
    document.addEventListener('keydown', event => {
      if (konami.dispatchKeyKode(event.keyCode.toString())){
        setKonamiState( konamiState => true);
        konami.animate()
      }
    });
    fetchProducts(localizedContent.products);
    setFTEligible();
    setUpWaData();
  }, []);


  return (
      <main id="uplayplus">
        <ContentProvider value={localizedContent}>
          <StyleSheetManager target={document.querySelector("#stylesheetsContainer")} disableCSSOMInjection={true}>
            <>
              <UbisoftPlusNavigation />

              {konamiState && konami.renderRainfall()}
              <Hero
                loaded={products.uplayData.ready}
                freeTrialEligible={products.uplayData.ftEligible}
              />
              {!products.uplayData.ready && !products.data.length && (
                <UbisoftPLusLoader />
              )}
              <Description />
              <BannerList />
              <Advantages
                loaded={products.uplayData.ready}
                freeTrialEligible={products.uplayData.ftEligible}
              />
              <div className={'banners_component_container ubisoft-connect-banner'}>
                <Banner bannerItem={localizedContent.ubisoftConnectBanner}
                        ctas={localizedContent.cta}
                />
              </div>
              <PriceBannerBlock />
              <FAQ />
              <Legal/>
          </>
          </StyleSheetManager>
        </ContentProvider>
      </main>
  );
};

export default connector(App);
